export default __webpack_public_path__ + "static/media/lightblue_logo_small.8be490cf.svg";